import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackageSingleStoryColumnsIntegrityProps {
    items: CuratedItem[] | undefined;
}
export default function integrityCheck({
    items,
}: StoryPackageSingleStoryColumnsIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["image"]);
}
